import { render } from "./BannerDefaultTagSectionCmp.vue?vue&type=template&id=5e389ef2"
import script from "./BannerDefaultTagSectionCmp.vue?vue&type=script&lang=js"
export * from "./BannerDefaultTagSectionCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__